// useBrowserLanguage.ts
import { ref, onMounted, Ref } from "vue";

// Define the return type of the composable function
interface UseBrowserLanguageReturn {
  browserLanguage: Ref<string>;
}

export function useBrowserLanguage(): UseBrowserLanguageReturn {
  const browserLanguage: Ref<string> = ref("en"); // Default to English

  onMounted(() => {
    // Use navigator.languages[0] for the most preferred language, falling back to navigator.language or navigator.userLanguage
    browserLanguage.value =
      navigator.languages && navigator.languages.length > 0
        ? navigator.languages[0].split("-")[0]
        : navigator.language.split("-")[0];

    console.info("Detected browser language:", browserLanguage.value);

    // Additional logic for mapping to supported languages and loading translations could be added here
  });

  return { browserLanguage };
}
